import IAuthUserRepository from 'domain/interfaces/repositories/IAuthUserRepository'

export const logoutAuthUserCommand = (repository: IAuthUserRepository, token: string) => {
  return repository.logout(token)
}
